import script from "./ShipsShop.vue?vue&type=script&setup=true&lang=js"
export * from "./ShipsShop.vue?vue&type=script&setup=true&lang=js"

import "./ShipsShop.vue?vue&type=style&index=0&id=0718ac9e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0718ac9e"]])

export default __exports__